export default __webpack_public_path__ + "static/media/table-tennis.f840ca56.jpg";